import React from "react";
import useApi from "../useApi";
import ColaboradoresApiClient from "../../api/colaboradores";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import { AppContext } from "../../contexts/AppContext";
import CommonSwal from "../../components/Swal/commonSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";

export default function useDadosContratuais(uid) {
  const [jornadas, setJornadas] = React.useState([]);
  const [jornada, setJornada] = React.useState([]);
  const [jornadaModal, setJornadaModal] = React.useState(false);
  const [jornadaValues, setJornadaValues] = React.useState({});
  const [dadosContratuaisOriginalValues, setDadosContratuaisOriginalValues] =
    React.useState({});
  const [dadosContratuaisValues, setDadosContratuaisValues] = React.useState(
    {}
  );
  const { session } = React.useContext(AppContext);

  const { request: getDadosContratuais, data: dadosContratuaisResponse } =
    useApi(ColaboradoresApiClient.getDadosContratuais);
  const { request: getDadosJornadas, data: dadosJornadasResponse } = useApi(
    ColaboradoresApiClient.getDadosJornadas
  );
  const putDadosContratuaisApi = useApi(
    ColaboradoresApiClient.putDadosContratuais
  );
  const postDadosJornadasApi = useApi(ColaboradoresApiClient.postDadosJornadas);
  const putDadosJornadasApi = useApi(ColaboradoresApiClient.putDadosJornadas);
  const deleteDadosJornadasApi = useApi(
    ColaboradoresApiClient.deleteDadosJornadas
  );

  //Busca jornadas de trabalho ao renderizar tela
  React.useEffect(() => {
    if (!session?.empresa) return;
    getDadosJornadas(session.empresa.replace(/E/gi, ""));
  }, [getDadosJornadas, session.empresa]);

  //Busca dados contratuais do colaborador ao renderizar tela
  React.useEffect(() => {
    if (!uid || !session?.empresa) return;
    getDadosContratuais(session.empresa.replace(/E/gi, ""), uid);
  }, [getDadosContratuais, session.empresa, uid]);

  //Define estado ao receber jornadas de trabalho
  React.useEffect(() => {
    if (!dadosJornadasResponse) return;
    setJornadas(() => [...dadosJornadasResponse]);
  }, [dadosJornadasResponse]);

  //Define estado ao receber dados contratuais do colaborador
  React.useEffect(() => {
    if (!dadosContratuaisResponse || !dadosJornadasResponse) return;
    setDadosContratuaisValues((prevValues) => ({
      ...prevValues,
      ...dadosContratuaisResponse,
    }));
    setDadosContratuaisOriginalValues((prevValues) => ({
      ...prevValues,
      ...dadosContratuaisResponse,
    }));
  }, [
    dadosContratuaisResponse,
    dadosJornadasResponse,
    setDadosContratuaisValues,
  ]);

  //Define valor da jornada de trabalho ao selecionar
  React.useEffect(() => {
    if (!dadosContratuaisValues?.uid_jornada || jornadas.length === 0) return;
    let selectedWorkingDay = jornadas.find(
      (jornada) => jornada.uid === dadosContratuaisValues?.uid_jornada
    );

    if (selectedWorkingDay) {
      const horarios = JSON.parse(selectedWorkingDay.horarios);

      const transformedHorarios = Object.keys(horarios).map((dia) => {
        return {
          dia_semana: dia,
          entrada: horarios[dia].entrada,
          saida: horarios[dia].saida,
          intervalo: selectedWorkingDay.intervalo,
        };
      });

      setJornada(transformedHorarios);
    }
  }, [jornadas, dadosContratuaisValues?.uid_jornada]);

  const togNovaJornadaModal = () => {
    setJornadaValues({});
    setJornadaModal(true);
  };

  const salvaDadosContratuais = (rascunho = false) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("uid_colaborador", uid);
      formData.append("cargo", dadosContratuaisValues?.cargo || "");
      formData.append("categoria", dadosContratuaisValues?.categoria || "");
      formData.append("salario", dadosContratuaisValues?.salario || "");

      if (!rascunho) {
        if (Validation.verificarForm(formData))
          return reject(
            ErrorSwal({
              text: "Favor preencher todos os dados obrigatórios.",
            })
          );
      }

      formData.append("uid_jornada", dadosContratuaisValues?.uid_jornada || "");

      putDadosContratuaisApi
        .request(session.empresa.replace(/E/gi, ""), uid, formData)
        .then((response) => {
          if (!response) return;

          resolve();
        });
    });
  };

  const salvaJornada = () => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("descricao", jornadaValues?.descricao);
      formData.append("horas_totais", jornadaValues?.horasSemanais);
      formData.append("intervalo", jornadaValues?.intervalo);

      if (Validation.verificarForm(formData))
        return reject(
          ErrorSwal({
            text: "Favor preencher todos os dados obrigatórios.",
          })
        );

      const horarios = JSON.stringify({
        "Segunda-feira": {
          entrada: jornadaValues?.entrada1 || "",
          saida: jornadaValues?.saida1 || "",
        },
        "Terça-feira": {
          entrada: jornadaValues?.entrada2 || "",
          saida: jornadaValues?.saida2 || "",
        },
        "Quarta-feira": {
          entrada: jornadaValues?.entrada3 || "",
          saida: jornadaValues?.saida3 || "",
        },
        "Quinta-feira": {
          entrada: jornadaValues?.entrada4 || "",
          saida: jornadaValues?.saida4 || "",
        },
        "Sexta-feira": {
          entrada: jornadaValues?.entrada5 || "",
          saida: jornadaValues?.saida5 || "",
        },
        Sábado: {
          entrada: jornadaValues?.entrada6 || "",
          saida: jornadaValues?.saida6 || "",
        },
        Domingo: {
          entrada: jornadaValues?.entrada7 || "",
          saida: jornadaValues?.saida7 || "",
        },
      });
      formData.append("horarios", horarios);

      jornadaValues?.uid
        ? putDadosJornadasApi
            .request(
              session.empresa.replace(/E/gi, ""),
              formData,
              jornadaValues?.uid
            )
            .then((response) => {
              if (!response) return;

              setJornadaModal(false);
              getDadosJornadas(session.empresa.replace(/E/gi, ""));
              CommonSwal({
                text: "Dados salvos com sucesso!",
                icon: "success",
              });
            })
        : postDadosJornadasApi
            .request(session.empresa.replace(/E/gi, ""), formData)
            .then((response) => {
              if (!response) return;

              setJornadaModal(false);
              getDadosJornadas(session.empresa.replace(/E/gi, ""));
              CommonSwal({
                text: "Dados cadastrados com sucesso!",
                icon: "success",
              });
            });
    });
  };

  const togEditarJornadaModal = async (uid) => {
    const editJornada = jornadas.find((jornada) => jornada.uid === uid);

    // Faz o parse da string JSON para um objeto
    const horarios = JSON.parse(editJornada.horarios);

    const diasDaSemana = [
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
      "Domingo",
    ];

    const horariosMapeados = diasDaSemana.reduce((acc, dia, index) => {
      const entradaKey = `entrada${index + 1}`;
      const saidaKey = `saida${index + 1}`;

      acc[entradaKey] = horarios[dia]?.entrada || "";
      acc[saidaKey] = horarios[dia]?.saida || "";

      return acc;
    }, {});

    setJornadaValues({
      ...editJornada,
      horasSemanais: editJornada.horas_totais,
      ...horariosMapeados,
    });
    setJornadaModal(true);
  };

  const excluirJornada = React.useCallback(
    async (uid_jornada) => {
      OptionsSwal({
        text: "Você deseja excluir essa jornada de trabalho?",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteDadosJornadasApi.request(
            session.empresa.replace(/E/gi, ""),
            uid_jornada
          );
          if (!response) return;
          getDadosJornadas(session.empresa.replace(/E/gi, ""));
        }
      });
    },
    [deleteDadosJornadasApi, getDadosJornadas, session.empresa]
  );

  return {
    jornadas,
    jornada,
    jornadaModal,
    setJornadaModal,
    jornadaValues,
    setJornadaValues,
    togNovaJornadaModal,
    salvaDadosContratuais,
    dadosContratuaisValues,
    setDadosContratuaisValues,
    salvaJornada,
    togEditarJornadaModal,
    excluirJornada,
    dadosContratuaisOriginalValues,
    setDadosContratuaisOriginalValues,
  };
}
